"use client"

import type React from "react"
import EditConnectorWizard from "./EditConnectorWizard"

const EditConnectorScreen: React.FC = () => {
  return (
    <div className="edit-connector-screen">
      <EditConnectorWizard />
    </div>
  )
}

export default EditConnectorScreen
